import script from "./BaseAbility.vue?vue&type=script&lang=ts&setup=true&name=BaseAbility"
export * from "./BaseAbility.vue?vue&type=script&lang=ts&setup=true&name=BaseAbility"

import "./BaseAbility.vue?vue&type=style&index=0&id=5ae68f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae68f8c"]])

export default __exports__